import { defineComponent } from 'vue';
import { mapState, useStore } from 'vuex';
import Loader from '@remote/components/Loader.vue';
import '@remote/assets/css/dialog.scss';
export default defineComponent({
  name: 'Dialog',
  components: {
    Loader
  },
  setup() {
    return {
      store: useStore()
    };
  },
  computed: {
    ...mapState(['dialog', 'deleteCompletely', 'showLoader']),
    action() {
      return this.dialog.action;
    },
    cancel() {
      return this.dialog.cancel;
    },
    hasCheck() {
      return this.dialog.hasCheck || false;
    },
    isIOS() {
      return !navigator.userAgent.includes('Android');
    }
  },
  methods: {
    close(type) {
      this.store.commit('dialog', {
        show: false
      });
      this.store.commit('update', {
        action: ''
      });
      setTimeout(() => {
        if (type === 'cancel' && this.cancel) this.store.commit('update', {
          action: this.cancel
        });
      }, 0);
    },
    handleAcion() {
      if (this.dialog.showLoader) {
        this.store.commit('update', {
          showLoader: true
        });
      }
      this.store.commit('update', {
        action: ''
      });
      setTimeout(() => {
        if (this.action) this.store.commit('update', {
          action: this.action
        });
      }, 0);
    },
    handleTip() {
      if (this.hasCheck) {
        this.store.commit('update', {
          deleteCompletely: !this.deleteCompletely
        });
      }
    }
  }
});